import omit from 'lodash/omit';
import createItem from './helpers/create-item';
import readList from './helpers/read-list';
import readItem from './helpers/read-item';
import updateItem from './helpers/update-item';
import deleteItem from './helpers/delete-item';
import {actionTypes} from 'redux-resource';

const RESOURCE_NAME = 'collections';
const UPLOADS_TASKS = ['posterTask'];

const uploadTaskRunner = task => entity => {
	if (task) {
		return task.upload(entity.id).then(() => entity);
	}
	return entity;
};

export const createCollection = values => dispatch => {
	dispatch({
		type: actionTypes.CREATE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'create'
	});

	const task = values.posterTask;
	const details = omit(values, UPLOADS_TASKS);

	return dispatch(createItem(RESOURCE_NAME, details))
		.then(uploadTaskRunner(task))
		.catch(error => {
			const status = error.isCanceled ?
				actionTypes.CREATE_RESOURCES_NULL :
				actionTypes.CREATE_RESOURCES_FAILED;

			dispatch({
				type: status,
				resourceName: RESOURCE_NAME,
				request: 'create'
			});
		});
};

export function readCollections() {
	return readList(RESOURCE_NAME, 'all');
}

export function readCollection(id) {
	return readItem(RESOURCE_NAME, id);
}

export const updateCollection = values => dispatch => {
	dispatch({
		type: actionTypes.UPDATE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'update'
	});

	const task = values.posterTask;
	const details = omit(values, UPLOADS_TASKS);

	return dispatch(updateItem(RESOURCE_NAME, details))
		.then(uploadTaskRunner(task))
		.catch(error => {
			const status = error.isCanceled ?
				actionTypes.UPDATE_RESOURCES_NULL :
				actionTypes.UPDATE_RESOURCES_FAILED;

			dispatch({
				type: status,
				resourceName: RESOURCE_NAME,
				request: 'update'
			});

			throw error;
		});
};

export function deleteCollection(id) {
	return deleteItem(RESOURCE_NAME, id);
}

export function dropStatus() {
	return dispatch => {
		dispatch({
			type: actionTypes.CREATE_RESOURCES_NULL,
			resourceName: RESOURCE_NAME,
			request: 'create'
		});

		dispatch({
			type: actionTypes.UPDATE_RESOURCES_NULL,
			resourceName: RESOURCE_NAME,
			request: 'update'
		});
	};
}



// WEBPACK FOOTER //
// ./src/client/redux/actions/collections.js